export default function isSection(item) {
    return !!item?.items;
}
